module.exports = new __parcel__URL__("mongodb.f3ec05fe.svg").toString();